export enum FUINavigationLinkAvailability {
    AVAILABLE,
    DISABLED,
    UNAVAILABLE
}

export class FUINavigationLink{
    public title: string;
    public action?: string;
    public nameSpace?: string;
    public entity?: string;
    public href?: string;
    public links?: FUINavigationLink[];
    public plugin?: string;
    public license?: string;
    public availabilityConfig?: string;

    public availability: Promise<FUINavigationLinkAvailability>;

    constructor(object?: any){
        this.title = object && object.title || null;
        this.action = object && object.action || null;
        this.nameSpace = object && object.nameSpace || null;
        this.entity = object && object.entity || null;
        this.href = object && (object.href || (object.entity && object.action && object.entity + "-" + object.action)) || null;
        this.links = object && object.links && object.links.map(link => new FUINavigationLink(link)) || null;
        this.plugin = object && object.plugin || null;
        this.license = object && object.license || null;
        this.availabilityConfig = object && object.availabilityConfig || null;
    }
}
